module.exports = __webpack_public_path__ + "static/img/mercantil.7553427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/mercantil.jpg
// module id = E7BS
// module chunks = 6